package ai.wagemix.net.client

import com.fsryan.foundation.net.client.FSAuthenticatedRequestBuilder
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.pathParamFollowing
import com.fsryan.foundation.net.client.replacePathParams

/**
 * `POST /api/v1/uploads/{uploadId}/retry`: runs a failed job-description upload's pipeline again on its file. 202
 * when started; 404 for another user's upload; 409 when it isn't failed; 410 when its file is gone; 503 without the
 * workflow service.
 */
class WMRetryUploadRequestBuilder: FSAuthenticatedRequestBuilder<WMRetryUploadRequestBuilder, Nothing>() {

    private var uploadId: String? = null

    fun uploadId(uploadId: String): WMRetryUploadRequestBuilder {
        this.uploadId = uploadId
        return this
    }

    override fun applyFrom(request: FSRequest<Nothing>): WMRetryUploadRequestBuilder {
        uploadId = request.pathParamFollowing("uploads")
        return super.applyFrom(request)
    }

    override fun build(): FSRequest<Nothing> {
        method(FSRequest.Method.Post)
        val id = uploadId ?: error("An upload id must be provided")
        replacePathParams("api", "v1", "uploads", id, "retry")
        return super.build()
    }

    override fun clear(): WMRetryUploadRequestBuilder {
        uploadId = null
        return super.clear()
    }

    override fun self(): WMRetryUploadRequestBuilder = this
}
